<template>
    <div v-if="model">
        <v-text-field
            label="Имя"
            v-model="model.display_name"
            :error-messages="errorsFor('display_name')"
        />

        <v-text-field
            label="Логин"
            v-model="model.username"
            :error-messages="errorsFor('username')"
        />

        <v-text-field
            label="Новый пароль"
            v-model="model.password"
            :error-messages="errorsFor('password')"
        />

        <v-select
            label="Роль"
            v-model="model.role"
            :items="roleList"
            item-value="id" item-text="name"
            :error-messages="errorsFor('role')"
        />
    </div>
</template>

<script lang="ts">
import {Component} from 'vue-property-decorator'
import {createUser, UserDraft} from '@/models/User'
import Form from '@/mixins/Form'

@Component({
    components: {},
})
export default class UserForm extends Form<UserDraft>
{
    roleList: object[] = [
        {id: 'admin', name: 'Администратор'},
        {id: 'operator', name: 'Оператор'},
    ]

    createModel(): UserDraft {
        return createUser()
    }
}
</script>
